// extracted by mini-css-extract-plugin
export default {"main":"style_main__nfWym","open":"style_open__6-H3F"};